/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthMonitorModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import {
    HealthMonitor,
    HealthMonitorSctp,
} from 'object-types';

import { L10nService } from '@vmw/ngx-vip';

import {
    HealthMonitorItem,
} from 'ajs/modules/healthmonitor/factories/health-monitor-item.factory';

import * as globalL10n from 'global-l10n';
import * as l10n from './sctp-health-monitor-config.l10n';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Health Monitor Config Component for SCTP Health Monitor Types.
 * @author Hitesh Mandav
 */
@Component({
    selector: 'sctp-health-monitor-config',
    templateUrl: './sctp-health-monitor-config.component.html',
})
export class SctpHealthMonitorConfigComponent {
    @Input()
    public editable: HealthMonitorItem;

    public readonly objectTypes = {
        HealthMonitor,
        HealthMonitorSctp,
    };

    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(private readonly l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
